module.exports = __webpack_public_path__ + "img/buy_super_ph.7fff1bbf.png";